import baseApi from "./RootBaseApi";
import { ApiResponse } from "@/types/api.types";

export interface BookingReminderConfig {
  hours: number;
}

export const BookingReminderConfigService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBookingReminderConfig: builder.query<
      ApiResponse<BookingReminderConfig>,
      void
    >({
      query: () => ({
        url: "/system-config/booking-reminder",
        method: "GET",
      }),
      keepUnusedDataFor: 0,
    }),
    updateBookingReminderConfig: builder.mutation<
      ApiResponse<BookingReminderConfig>,
      { hours: number }
    >({
      query: ({ hours }) => ({
        url: "/system-config/booking-reminder",
        method: "PUT",
        data: { hours },
      }),
    }),
    resetBookingReminderConfig: builder.mutation<
      ApiResponse<BookingReminderConfig>,
      void
    >({
      query: () => ({
        url: "/system-config/booking-reminder",
        method: "PUT",
        data: { hours: 24 },
      }),
    }),
  }),
});

export const {
  useGetBookingReminderConfigQuery,
  useUpdateBookingReminderConfigMutation,
  useResetBookingReminderConfigMutation,
} = BookingReminderConfigService;
